export default function FlightsMultitripListController(
    $scope,
    $controller,
    flightsFactory,
    flightsService
) {
    'ngInject';

    const vm = this;

    $controller('FlightsListBaseController', {
        $scope,
        flightsFactory,
    });

    Object.assign(vm, {
        isMultiSegmentFlight: flightsService.isMultiSegmentFlight,
        isTwoSegmentFlight: flightsService.isTwoSegmentFlight,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flights-multitrip-list-controller.js